import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionsService } from '../sessions.service';
import { Translation } from '../../../providers/translation';
import { ISession } from '../../../models/session';
import * as languageList from 'language-list';
import * as moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { pick } from 'ramda/es';
import { CustomizationService } from '../../customization/customization.service';

const toCode = lang => languageList().getLanguageCode(lang);
const empty = [];
@Component({
  templateUrl: './sessions-list.component.html',
  styleUrls: ['./sessions-list.component.scss']
})
export class SessionsListComponent implements OnInit {
  public sessionsTypes = {
    teasing: [],
    live: [],
    over: [],
    replay: []
  };

  public typeIcons = {
    teasing: 'fire',
    live: 'play',
    over: 'check',
    replay: 'upload'
  };

  public hidden = [];
  public modelType;
  public modalRef: BsModalRef;
  public accountConfig = {};

  private selectedSession: ISession;
  // Subscribe
  private lang$;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sessionService: SessionsService,
    private modalService: BsModalService,
    private translate: TranslateService,
    private lang: Translation,
    private customizationService: CustomizationService
  ) {}

  ngOnDestroy() {
    if (this.lang$) {
      this.lang$.unsubscribe();
    }
  }

  ngOnInit() {
    this.lang$ = this.lang.translate.onLangChange.subscribe(event => {
      const newCode = toCode(event.lang);
      moment.locale(newCode);
    });
    this.route.data
      .map(route => route.data)
      .subscribe(
        (sessions: ISession[] = []) => {
          if (!sessions || sessions.length === 0) {
            return this.router.navigateByUrl('/sessions/create');
          }
          const code = toCode(this.lang.translate.currentLang || this.lang.translate.defaultLang);
          moment.locale(code);

          const teasing = sessions.filter(session => session.eurostudioStatus === 'BOOKED');
          const live = sessions.filter(session => session.status === 'STARTED');
          const over = sessions.filter(
            session =>
              session.eurostudioStatus === 'CLOSED' || session.eurostudioStatus === 'STOPPED'
          );
          const replay = sessions.filter(session => session.eurostudioStatus === 'PUBLISHED');

          this.sessionsTypes = {
            teasing,
            live,
            over,
            replay
          };
        },
        () => {
          this.router.navigateByUrl('/sessions/create');
        }
      );
      this.customizationService.getAccountConfig().subscribe(config => {
        this.accountConfig = config;
      });
  }

  openModal(template: TemplateRef<any>, session: any) {
    this.selectedSession = session;
    this.modalRef = this.modalService.show(template, { class: 'inmodal' });
  }

  duplicateSession() {
    toastr.warning(this.translate.instant('sessions.create.slow_warning'));
    this.closeModal();
    const payload = pick(
      ['types', 'date', 'expirationdatetime', 'name', 'description'],
      this.selectedSession
    );
    this.sessionService
      .duplicate(
        this.selectedSession.id,
        { ...payload, name: this.appendSuffix(payload.name) },
        false
      )
      .subscribe(
        () => {
          toastr.success(this.translate.instant('sessions.create.session_created'));
          this.router.navigate(['/sessions']);
        },
        err => {
          toastr.error(this.translate.instant('sessions.create.session_not_created'));
        }
      );
  }

  closeModal() {
    this.modalRef.hide();
  }

  toggleHide(data: any) {
    if (this.hidden.indexOf(data) >= 0) {
      this.hidden = this.hidden.filter(hide => hide !== data);
    } else {
      this.hidden.push(data);
    }
  }

  formatDate(date: any) {
    return moment(date).format('LL');
  }

  isSameDay(date1: string, date2: string): boolean {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }

  /**
   * Check if name already contain a duplication number and increment it e.g. (2)
   * Make sure result name fit max limit in 50 symbols
   */
  appendSuffix(name: string): string {
    const match = /^(.*)(?:\s*\((\d+)\))$|^(.*)$/.exec(name);
    if (match) {
      const base = (match[1] || match[3]).trim();
      const index = match[2] || 0;
      const suffix = ` (${+index + 1})`;
      return base.substr(0, Math.min(base.length, 50 - suffix.length)) + suffix;
    }
    return name;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/list/sessions-list.component.ts